import React, { useEffect, useState, useCallback } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { history } from "../../../shared/_helpers/history";
import { ButtonGroup, Dropdown, Nav } from "react-bootstrap";
import Switch from "react-switch";
import Tick from "../../../assets/tick.png";
import UnTick from "../../../assets/untick.png";
import { TableRow } from "./TableRow";
import { getDateFromISOOne } from "../../../shared/utils";
import DropDn from "../../../assets/icons/drop.png";
import { AlertMsg } from "../../../shared/components/alert-msg";
import { TableComponent } from "../../../shared/components/table";
import ReactPaginate from "react-paginate";
import { LoadingItem } from "../../../shared/components/loading";
import NotificationPopup from "./NotificationPopup";
import DeleteConfirmModal from "./DeleteConfirmModal";
import { useDebounce } from "use-debounce";

import FilterModal from "./FilterModal";
import { Product } from "../../../types/ProductTypes";
import CustomPagination from "../../../shared/components/pagination/CustomPagination";
import { useLocation, useNavigate } from "react-router-dom";

interface ReportTableTypes {
  reportData: Product[];
  handleBulkDelete: () => void;
  handleBulkUpdate: () => void;
  handleBulkReactivate: () => void;
}

const bulkProductUpdateAction = async ({
  pageProps,
  payload,
}: {
  pageProps: any;
  payload: any;
}) => {
  await pageProps.bulkProductUpdate(payload, "edit");
};

const bulkProductDeleteAction = async ({
  pageProps,
  payload,
}: {
  pageProps: any;
  payload: any;
}) => {
  await pageProps.bulkProductUpdate(payload, "delete");
};
const deleteStoreProductAction = async ({ pageProps, payload }: any) => {
  await pageProps.deleteStoreProduct(payload);
};

const getProducts = async ({
  pageProps,
  payload,
}: {
  pageProps: any;
  payload: any;
}) => {
  await pageProps.getMyProductList(payload);
};

const toggleProduct = async ({
  pageProps,
  payload,
  callback,
}: {
  pageProps: any;
  payload: any;
  callback?: () => void;
}) => {
  await pageProps.toggleAProduct(payload, callback);
};

const permanentDeleteAction = async ({ pageProps, payload }: any) => {
  await pageProps.permanentDeleteProduct(payload);
};

const statuses = ["All", "Shown", "Hidden", "Trash"];
// const statuses = ["All", "Shown", "Hidden"];

const defaultProductFilterValues = {
  productNames: "",
  category: [],
  status: "All",
  minPrice: "0",
  maxPrice: "1000",
  lowStockOnly: false,
};

const getInitialStatus = () => {
  const status = new URLSearchParams(window.location.search).get("status");
  return status && statuses.includes(status) ? status : "All";
};

const getInitialProductFilters = () => {
  const params = new URLSearchParams(window.location.search);
  const hasFilters = [
    "productNames",
    "category",
    "filterStatus",
    "minPrice",
    "maxPrice",
    "lowStockOnly",
  ].some((key) => params.has(key));

  if (!hasFilters) return null;

  return {
    productNames: params.get("productNames") || "",
    category: params.getAll("category"),
    status: params.get("filterStatus") || "All",
    minPrice: Number(params.get("minPrice") || defaultProductFilterValues.minPrice),
    maxPrice: Number(params.get("maxPrice") || defaultProductFilterValues.maxPrice),
    lowStockOnly: params.get("lowStockOnly") === "true",
  };
};

export const InAppContent = ({ pageProps }: any) => {
  const [startDate, onStartChange] = useState<any>();
  const [activeStatus, setActiveStatus] = useState<string>(getInitialStatus);
  const [endDate, onEndChange] = useState<any>();
  const [showBulkUpdateModal, setShowBulkUpdateModal] =
    useState<boolean>(false);
  const [bulkUpdateSuccessMessage, setBulkUpdateSuccessMessage] =
    useState<string>("");
  const screenResolution: any = useWindowSize();
  const [deleteCount, setDeleteCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] =
    useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(null);
  const [deleteType, setDeleteType] = useState<"trash" | "permanent">("trash");

  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page") as string) || 1;

  const [pageNumber, setPageNumber] = useState(initialPage);

  useEffect(() => {
    if (
      pageProps.deleteStoreProductRequest.request_status ===
      "DELETE_A_PRODUCT_SUCCESS"
    ) {
      setSelectedRows([]);
      setActiveInputId(null);
      setEditedData([]);
      handleProductListRefresh();
      setShowDeleteConfirmModal(false);
      setItemToDelete(null);
      setShowBulkUpdateModal(true);
      setBulkUpdateSuccessMessage(
        `Product ${deleteType === "permanent" ? "permanently deleted" : "moved to trash"
        }.`
      );
      deleteStoreProductAction({ pageProps, payload: "CLEAR" });
    }
  }, [pageProps.deleteStoreProductRequest.request_status]);

  const [pageSize, setPageSize] = useState(10);

  const [searchText, setSearchText] = useState(
    () => new URLSearchParams(window.location.search).get("search") || ""
  );
  const [debouncedSearchText] = useDebounce(searchText, 500); // delay 500ms
  const [bulkAction, setBulkAction] = useState("");
  const [shownData, setDataShownData] = useState<any[]>([]);
  const [originalData, setOriginalData] = useState<any[]>([]); // Store original data
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [editedData, setEditedData] = useState<any[]>([]);
  const [formattedData, setFormattedData] = useState<any[]>([]);
  const [bulkEditValues, setBulkEditValues] = useState({ name: "", age: "" });
  const [activeInputId, setActiveInputId] = useState<string | null>(null);
  const [categoryList, setCategoryList] = useState<
    { label: string; value: string }[]
  >([]);
  let toogleRequest = pageProps.toggleProductRequest;
  let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
  loggedAccountInfo = JSON.parse(loggedAccountInfo);

  const [showFilterModal, setShowFilterModal] = useState(false);
  const [activeFilters, setActiveFilters] = useState<any>(
    getInitialProductFilters
  );

  const [productFilterValues, setProductFilterValues] = useState<{
    productNames: string;
    category: string[];
    status: string;
    minPrice: string;
    maxPrice: string;
    lowStockOnly: boolean;
  }>(() => {
    const initialFilters = getInitialProductFilters();
    return initialFilters
      ? {
        productNames: initialFilters.productNames,
        category: initialFilters.category,
        status: initialFilters.status,
        minPrice: String(initialFilters.minPrice),
        maxPrice: String(initialFilters.maxPrice),
        lowStockOnly: initialFilters.lowStockOnly,
      }
      : defaultProductFilterValues;
  });

  const productListReturnTo = `${location.pathname}${location.search}`;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", pageNumber.toString());

    const trimmedSearchText = debouncedSearchText.trim();
    if (trimmedSearchText.length >= 3) {
      params.set("search", trimmedSearchText);
    } else {
      params.delete("search");
    }

    if (activeStatus !== "All") {
      params.set("status", activeStatus);
    } else {
      params.delete("status");
    }

    [
      "productNames",
      "category",
      "filterStatus",
      "minPrice",
      "maxPrice",
      "lowStockOnly",
    ].forEach((key) => params.delete(key));

    if (activeFilters) {
      if (activeFilters.productNames?.trim()) {
        params.set("productNames", activeFilters.productNames.trim());
      }
      if (Array.isArray(activeFilters.category)) {
        activeFilters.category.forEach((category: string) => {
          params.append("category", category);
        });
      }
      if (activeFilters.status && activeFilters.status !== "All") {
        params.set("filterStatus", activeFilters.status);
      }
      params.set("minPrice", String(activeFilters.minPrice));
      params.set("maxPrice", String(activeFilters.maxPrice));
      params.set("lowStockOnly", String(activeFilters.lowStockOnly));
    }

    const nextSearch = params.toString();
    if (nextSearch !== location.search.replace(/^\?/, "")) {
      navigate(`?${nextSearch}`, { replace: true });
    }
  }, [
    pageNumber,
    debouncedSearchText,
    activeStatus,
    activeFilters,
    location.search,
    navigate,
  ]);

  const handleProductListRefresh = () => {
    const payload = `Page=${pageNumber}&Size=${pageSize}${searchText ? `&SearchText=${searchText}` : ""
      }${activeStatus === "Shown" ? "&Status=Active" : ""}${activeStatus === "Hidden" ? "&Status=InActive" : ""
      }${activeStatus === "Trash" ? "&Status=IsDeleted" : ""}`;

    getProducts({ pageProps, payload }).then(() => {
      const aggregateResults =
        pageProps?.getProductListRequest?.request_data?.response?.aggregateResults;

      const categoriesData = Array.isArray(aggregateResults)
        ? aggregateResults.find((item) => item?.name === "Categories")
        : null;

      const categories =
        Array.isArray(categoriesData?.buckets)
          ? categoriesData.buckets.map((bucket: { value: string, key: string }) => ({
            label: bucket?.key ?? "",
            value: bucket?.value ?? "",
          }))
          : [];

      setCategoryList(categories || []);
    });
  };
  useEffect(() => {
    bulkProductUpdateAction({
      pageProps,
      payload: "CLEAR",
    });
    deleteStoreProductAction({
      pageProps,
      payload: "CLEAR",
    });
    let payload = `Page=${pageNumber}&Size=${pageSize}`;
    getProducts({ pageProps, payload }).then(() => {
      const aggregateResults =
        pageProps?.getProductListRequest?.request_data?.response?.aggregateResults;

      const categoriesData = Array.isArray(aggregateResults)
        ? aggregateResults.find((item) => item?.name === "Categories")
        : null;

      const categories =
        Array.isArray(categoriesData?.buckets)
          ? categoriesData.buckets.map((bucket: { value: string, key: string }) => ({
            label: bucket?.key ?? "",
            value: bucket?.value ?? "",
          }))
          : [];

      // Fallback to empty array if nothing found
      setCategoryList(categories || []);
    });

    toggleProduct({ pageProps, payload: "CLEAR" });
  }, []);

  useEffect(() => {
    if (
      pageProps.getProductListRequest.request_status === "GET_PRODUCTS_SUCCESS"
    ) {
      const newData =
        pageProps.getProductListRequest.request_data.response?.results || [];
      setDataShownData(newData);
      setOriginalData(newData); // Store original data
    }
  }, [pageProps.getProductListRequest]);

  useEffect(() => {
    if (
      pageProps.bulkProductUpdateRequest.request_status ===
      "BULK_UPDATE_SUCCESS"
    ) {
      setSelectedRows([]);
      setActiveInputId(null);
      setEditedData([]);
      handleProductListRefresh();
      if (bulkAction === "delete") {
        setShowBulkUpdateModal(true);
        setBulkUpdateSuccessMessage(`${deleteCount} products moved to trash.`);
      } else if (bulkAction === "edit") {
        setShowBulkUpdateModal(true);
        setBulkUpdateSuccessMessage(
          `${formattedData.length} products have been updated.`
        );
      } else if (bulkAction === "reactivate") {
        setShowBulkUpdateModal(true);
        setBulkUpdateSuccessMessage(
          `${formattedData.length} products restored successfully.`
        );
      }
      // clear local tracking state
      bulkProductUpdateAction({ pageProps, payload: "CLEAR" });
      setBulkAction("");
      setFormattedData([]);
      setDeleteCount(0);
    }
  }, [pageProps.bulkProductUpdateRequest.request_status]);

  useEffect(() => {
    if (
      pageProps.deleteStoreProductRequest.request_status ===
      "DELETE_A_PRODUCT_SUCCESS"
    ) {
      setSelectedRows([]);
      setActiveInputId(null);
      setEditedData([]);
      handleProductListRefresh();

      deleteStoreProductAction({ pageProps, payload: "CLEAR" });
    }
  }, [pageProps.deleteStoreProductRequest.request_status]);

  const handleActiveChange = (id: string, isActive: boolean) => {
    setDataShownData((prev) =>
      prev.map((item) => (item.id === id ? { ...item, isActive } : item))
    );

    setEditedData((prev) => {
      const existingEdit = prev.find((edit) => edit.id === id);
      if (existingEdit) {
        return prev.map((edit) =>
          edit.id === id ? { ...edit, isActive } : edit
        );
      }
      return [...prev, { id, isActive }];
    });
  };

  const handleCheckboxChange = (id: any) => {
    bulkProductUpdateAction({
      pageProps,
      payload: "CLEAR",
    });
    setSelectedRows((prev: any) => {
      if (prev.includes(id)) {
        // Row is being unchecked, revert to original values
        const originalRow = originalData.find((item) => item.id === id);
        if (originalRow) {
          setDataShownData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...originalRow } : item))
          );
          // Remove from editedData
          setEditedData((prevEdited) =>
            prevEdited.filter((edit) => edit.id !== id)
          );
        }
        return prev.filter((rowId: any) => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      setSelectedRows(shownData.map((item: any) => item.id));
    } else {
      // Revert all rows to original values when deselecting all
      setDataShownData([...originalData]);
      setEditedData([]); // Clear all edits
      setSelectedRows([]);
      setActiveInputId(null);
    }
  };

  const handleInputChange = (id: string, field: string, value: string) => {
    setDataShownData((prev: any) => {
      const updatedData = prev.map((item: any) => {
        if (item.id === id) {
          if (field === "newPrice") {
            return {
              ...item,
              newPrice: Number(value || "0"),
              // price: {
              //     ...item.price,
              //     amount: value
              // }
            };
          }
          return { ...item, [field]: value };
        }
        return item;
      });
      return updatedData;
    });

    setEditedData((prev: any) => {
      const existingEdit = prev.find((edit: any) => edit.id === id);
      if (existingEdit) {
        return prev.map((edit: any) => {
          if (edit.id === id) {
            if (field === "newPrice") {
              return {
                ...edit,
                newPrice: Number(value || "0"),
                // price: {
                //     ...edit.price,
                //     amount: value
                // }
              };
            }
            return { ...edit, [field]: value };
          }
          return edit;
        });
      }
      if (field === "newPrice") {
        return [
          ...prev,
          {
            id,
            newPrice: Number(value || "0"),
            // price: { amount: value }
          },
        ];
      }
      return [...prev, { id, [field]: value }];
    });
  };

  const handleBulkEditChange = (field: any, value: any) => {
    setBulkEditValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleBulkEdit = () => {
    setDataShownData((prev: any) =>
      prev.map((item: any) =>
        selectedRows.includes(item?.id)
          ? {
            ...item,
            name: bulkEditValues.name || item.name,
            age: bulkEditValues.age || item.age,
          }
          : item
      )
    );
    setEditedData((prev: any) => {
      const updatedEdits = selectedRows.map((id) => {
        const existingEdit = prev.find((edit: any) => edit.id === id) || { id };
        return {
          ...existingEdit,
          ...(bulkEditValues.name && { name: bulkEditValues.name }),
          ...(bulkEditValues.age && { age: bulkEditValues.age }),
        };
      });
      const otherEdits = prev.filter(
        (edit: any) => !selectedRows.includes(edit.id)
      );
      return [...otherEdits, ...updatedEdits];
    });
    setBulkEditValues({ name: "", age: "" });
  };

  const getUpdatedRows = () => {
    return editedData.map((edit) => {
      const originalItem = shownData.find((item: any) => item.id === edit.id);
      return { ...originalItem, ...edit };
    });
  };
  const handleBulkDelete = () => {
    const payload = {
      storeId: loggedAccountInfo?.selectedStore?.id,
      productIds: selectedRows,
    };
    if (selectedRows.length >= 1) {
      setBulkAction("delete");
      setDeleteCount(selectedRows.length);
      bulkProductDeleteAction({ pageProps, payload });
    } else {
      setShowBulkUpdateModal(true);
    }
  };

  // Move to trash function
  const handleMoveToTrash = (id: string) => {
    setItemToDelete({ id, type: "single" });
    setDeleteType("trash");
    setShowDeleteConfirmModal(true);
  };

  // Permanent delete function
  const handlePermanentDelete = (id: string) => {
    setItemToDelete({ id, type: "single" });
    setDeleteType("permanent");
    setShowDeleteConfirmModal(true);
  };

  // Reactivate product from Trash
  const handleReactivate = (id: string) => {
    const payload = {
      storeId: loggedAccountInfo?.selectedStore?.id,
      productId: id,
      status: "Active",
    };

    toggleProduct({
      pageProps,
      payload,
      callback: () => {
        handleProductListRefresh();
        setShowBulkUpdateModal(true);
        setBulkUpdateSuccessMessage("Product reactivated successfully.");
      },
    });
  };

  // Reactivate product(s) from Trash
  const handleBulkReactivate = () => {
    // guard
    if (!selectedRows || selectedRows.length === 0) {
      console.log("No products selected for restore.");
      setShowBulkUpdateModal(true);
      setBulkUpdateSuccessMessage("No products selected for restore.");
      return;
    }

    // Build updates directly from selectedRows
    const formatedUpdates = selectedRows.map((id: string) => ({
      productId: id,
      activate: true, // backend expects 'activate' like bulk edit does
    }));

    const payload = {
      storeId: loggedAccountInfo?.selectedStore?.id, // use loggedAccountInfo instead of updatedData[0]?.storeId
      updates: formatedUpdates,
    };

    setBulkAction("reactivate");
    // reuse existing bulk action helper
    bulkProductUpdateAction({ pageProps, payload });
    setFormattedData(formatedUpdates);
  };

  // Confirm delete action
  const confirmDeleteAction = () => {
    if (!itemToDelete) return;

    const payload = {
      storeId: loggedAccountInfo?.selectedStore?.id,
      productId: itemToDelete.id,
    };

    setDeleteCount(1);

    if (deleteType === "permanent") {
      // Call permanent delete API
      permanentDeleteAction({ pageProps, payload });
    } else {
      // Move to trash (existing delete functionality)
      deleteStoreProductAction({ pageProps, payload });
    }
  };

  const handleDeleteStoreProduct = (id: string) => {
    const payload = {
      storeId: loggedAccountInfo?.selectedStore?.id,
      productId: id,
    };
    setDeleteCount(1);
    deleteStoreProductAction({ pageProps, payload });
  };
  const handleBulkUpdate = () => {
    let updatedData: any = getUpdatedRows();

    let formatedUpdates = updatedData.map((eachItem: any) => {
      return {
        productId: eachItem?.id,
        newPrice: eachItem?.newPrice ?? null,
        price: {
          ...eachItem?.price,
          amount: eachItem?.newPrice ?? eachItem?.price?.amount,
        },
        discountPrice: eachItem?.discountPrice,
        quantity: Number(eachItem?.availableQuantity),
        activate: eachItem?.isActive,
      };
    });

    let payload = {
      storeId: updatedData?.[0]?.storeId ?? loggedAccountInfo?.selectedStore?.id,
      updates: formatedUpdates,
    };

    if (formatedUpdates.length >= 1) {
      setBulkAction("edit");
      bulkProductUpdateAction({ pageProps, payload });
      setFormattedData(formatedUpdates);
    } else {
      console.log("No updates to process.");
    }
  };

  const EachProductStatus = ({ eachItem, pageProps }: any) => {
    const [productStatus, setProductStatus] = useState<boolean>(
      eachItem.isActive
    );
    const [productInfo, setProductInfo] = useState<any>(eachItem);

    useEffect(() => {
      if (productStatus !== eachItem.isActive) {
        let togglePayload = {
          storeId: eachItem?.storeId,
          productId: eachItem?.id,
        };

        let payload = `Page=${pageNumber}&Size=${pageSize}`;

        toggleProduct({
          pageProps,
          payload: togglePayload,
          callback: () => {
            getProducts({
              pageProps,
              payload,
            });
          },
        });
      }
    }, [productStatus]);

    return (
      <Switch
        checkedIcon={true}
        checkedHandleIcon={<img className="tick_img" src={Tick} />}
        uncheckedHandleIcon={<img className="un_tick_img" src={UnTick} />}
        uncheckedIcon={true}
        width={40}
        height={20}
        disabled={pageProps.toggleProductRequest.is_request_processing}
        onHandleColor="#FFFFFF"
        onColor="#00A85B"
        offHandleColor="#9B9B9B"
        offColor="#D8D8D8"
        onChange={() => setProductStatus(!productStatus)}
        checked={productStatus}
      />
    );
  };

  const ReportTable = ({
    reportData,
    handleBulkDelete,
    handleBulkUpdate,
    handleBulkReactivate,
  }: ReportTableTypes) => {
    let updatedData = reportData
      .filter((eachData: Product) => {
        if (activeStatus === "Shown" && eachData.availableQuantity <= 0) {
          return false;
        }

        return true;
      })
      .map((eachData: Product) => {
        return {
          ...eachData,
          newPrice: eachData?.newPrice || eachData?.price?.amount,
        };
      });

    return (
      <>
        <thead>
          <tr>
            <th>
              <span>
                <div className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={
                      selectedRows.length === reportData.length &&
                      reportData.length > 0
                    }
                    onChange={handleSelectAll}
                  />
                </div>
              </span>
            </th>
            {selectedRows?.length > 0 ? (
              <th colSpan={7} className="bulk-actions-header">
                {/* <div className="bulk-actions-wrap">
                  <button className="bulk-btn save" onClick={handleBulkUpdate}>
                    Save
                  </button>
                  <button
                    className="bulk-btn delete"
                    onClick={handleBulkDelete}
                  >
                    Delete
                  </button>
                </div> */}
                <div className="bulk-actions-wrap">
                  {activeStatus !== "Trash" && (
                    <button
                      className="bulk-btn save"
                      onClick={handleBulkUpdate}
                    >
                      Save
                    </button>
                  )}
                  {activeStatus === "Trash" && (
                    <button
                      className="bulk-btn reactivate"
                      onClick={handleBulkReactivate}
                    >
                      Restore
                    </button>
                  )}

                  {activeStatus !== "Trash" && (
                    <button
                      className="bulk-btn delete"
                      onClick={handleBulkDelete}
                    >
                      Move to Trash
                      {/* {activeStatus === "Trash"
                      ? "Delete Permanently"
                      : "Move to Trash"} */}
                    </button>
                  )}
                </div>
              </th>
            ) : (
              <>
                <th>Product</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Category</th>
                <th>Created On</th>
                <th>Rating</th>
                <th>
                  <span>Show / Hide</span>
                </th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {updatedData.map((eachItem: any, index: any) => (
            <TableRow
              key={eachItem.id}
              eachItem={eachItem}
              index={index}
              isSelected={selectedRows.includes(eachItem.id)}
              handleCheckboxChange={handleCheckboxChange}
              handleDeleteStoreProduct={handleDeleteStoreProduct}
              handleMoveToTrash={handleMoveToTrash}
              handlePermanentDelete={handlePermanentDelete}
              handleReactivate={handleReactivate}
              handleInputChange={handleInputChange}
              handleActiveChange={handleActiveChange}
              pageProps={{ ...pageProps, pageNumber, pageSize }}
              productListReturnTo={productListReturnTo}
              activeInputId={activeInputId}
              setActiveInputId={setActiveInputId}
              activeStatus={activeStatus}
            />
          ))}
        </tbody>
      </>
    );
  };

  const handlePageClick = (event: any) => {
    setPageNumber(event?.selected + 1);
    setActiveInputId(null);
  };

  const MobileDataGrid = ({ reportData }: any) => {
    let updatedData = (reportData?.results && Array.isArray(reportData.results) ? reportData.results : [])
      .filter((eachData: Product) => {
        if (activeStatus === "Shown" && eachData.availableQuantity <= 0) {
          return false;
        }
        return true;
      })
      .map((eachData: Product) => {
        return {
          ...eachData,
          newPrice: eachData?.newPrice || eachData?.price?.amount,
        };
      });
    return (
      <div className="mobile-data-grid">
        {updatedData.length >= 1 && (
          <>
            {updatedData.map((eachItem: any, index: any) => (
              <div className="each_data_item" key={index}>
                <div className="main-txt-head">
                  <div className="prod_def">
                    <div className="prod_img">
                      <img src={eachItem?.urls[0]} alt="" />
                    </div>
                    <div className="prod_name_cat">
                      <div className="name_only">{eachItem?.name}</div>
                      <div className="all_cat_list">
                        {Array.isArray(eachItem?.categories) && eachItem.categories.map((eachCat: any, idx: any) => (
                          <span className="cate" key={idx}>
                            {eachCat}
                            {idx + 1 < eachItem.categories.length ? "," : ""}
                          </span>
                        ))}
                        {(!eachItem?.categories || eachItem.categories.length === 0) ? "N/A" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="other_action">
                    <div className="product-actions">
                      {activeStatus !== "Trash" && (
                        <div className="is-active">
                          <EachProductStatus
                            eachItem={eachItem}
                            pageProps={pageProps}
                          />
                        </div>
                      )}
                      <Dropdown className="report_dropdown" as={ButtonGroup}>
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className="action-cta"
                        >
                          <img src={DropDn} alt="" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {activeStatus !== "Trash" && (
                            <>
                              <Dropdown.Item
                                href={`/app/my-products/${eachItem.id}/edit?returnTo=${encodeURIComponent(
                                  productListReturnTo
                                )}`}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleMoveToTrash(eachItem.id)}
                              >
                                Move to Trash
                              </Dropdown.Item>
                            </>
                          )}
                          {activeStatus === "Trash" && (
                            <>
                              <Dropdown.Item
                                onClick={() => handleReactivate(eachItem.id)}
                              >
                                Restore
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() =>
                                  handlePermanentDelete(eachItem.id)
                                }
                              >
                                Delete Permanently
                              </Dropdown.Item>
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="each_mobile_prod_info">
                  <div className="title-txt">Is this product taxable?</div>
                  <div className="availables">
                    <input
                      type="checkbox"
                      checked={eachItem?.isTaxable}
                      disabled
                    />
                  </div>
                </div>
                <div className="each_mobile_prod_info">
                  <div className="title-txt">Quantity</div>
                  <div className="availables">{eachItem.availableQuantity}</div>
                </div>
                <div className="each_mobile_prod_info">
                  <div className="title-txt">Price</div>
                  <div className="availables price_txt">
                    ${eachItem.newPrice}
                  </div>
                  {/* <div className="availables price_txt">${eachItem.price?.amount}</div> */}
                </div>
                <div className="each_mobile_prod_info">
                  <div className="title-txt">Rating</div>
                  <div className="availables">
                    {eachItem?.ratingSummary &&
                      eachItem?.ratingSummary.count >= 1 && (
                        <>
                          {eachItem?.ratingSummary.averageRating}{" "}
                          <span className="unit-price">
                            ({eachItem.ratingSummary.count})
                          </span>
                        </>
                      )}
                    (
                    {eachItem?.ratingSummary &&
                      eachItem?.ratingSummary.count === 0
                      ? "N/A"
                      : ""}
                    )
                  </div>
                </div>
                <div className="each_mobile_prod_info">
                  <div className="title-txt">Created on</div>
                  <div className="availables">
                    <div className="date-item">
                      {getDateFromISOOne({
                        date: eachItem.createdDate,
                        returnTime: false,
                        hasDivider: true,
                      }) || "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    );
  };
  const handleFilterSearch = useCallback(
    (filters: {
      productNames: string;
      category: Array<string>;
      status: string;
      minPrice: number;
      maxPrice: number;
      lowStockOnly: boolean;
    }) => {
      let query = `Page=${pageNumber}&Size=${pageSize}&IsVendor=true`;

      if (filters.productNames?.trim()) {
        query += `&SearchText=${encodeURIComponent(
          filters.productNames.trim()
        )}`;
      }

      if (filters.minPrice != null) {
        query += `&PriceFrom=${filters.minPrice}`;
      }

      if (filters.maxPrice != null) {
        query += `&PriceTo=${filters.maxPrice}`;
      }

      if (filters.status === "Active") {
        query += `&Status=Active`;
      } else if (filters.status === "Inactive") {
        query += `&Status=InActive`;
      }

      if (filters.lowStockOnly === true) {
        query += `&LowStockOnly=true`;
      } else if (filters.lowStockOnly === false) {
        query += `&LowStockOnly=false`;
      }

      // if (filters.category && Array.isArray(filters.category) && filters.category.length > 0 && filters.category[0] !== 'All') {
      //     query += `&Categories=${filters.category[0]}`;
      //     console.log("Selected categories:", filters.category.join(","));
      // }

      if (
        filters.category &&
        Array.isArray(filters.category) &&
        filters.category.length > 0 &&
        filters.category[0] !== "All"
      ) {
        filters.category.forEach((cat) => {
          query += `&Categories=${encodeURIComponent(cat)}`;
        });
      }

      getProducts({ pageProps, payload: query });
    },
    [pageNumber, pageSize, pageProps]
  );

  useEffect(() => {
    if (activeFilters) {
      handleFilterSearch(activeFilters);
    } else {
      //   let payload = `Page=${pageNumber}&Size=${pageSize}`;
      const trimmedSearchText = debouncedSearchText.trim();
      let payload = `Page=${pageNumber}&Size=${pageSize}${trimmedSearchText.length >= 3 ? `&SearchText=${trimmedSearchText}` : ""
        }${activeStatus === "Shown" ? "&Status=Active" : ""}${activeStatus === "Hidden" ? "&Status=InActive" : ""
        }${activeStatus === "Trash" ? "&Status=IsDeleted" : ""}`;
      getProducts({ pageProps, payload });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, pageSize, activeFilters, debouncedSearchText, activeStatus]);

  return (
    <div className="inapp-content">
      <div
        className={`page-content lists-wrap with-heading ${pageProps.bulkProductUpdateRequest.is_request_processing
            ? "ongoing-update"
            : ""
          }`}
      >
        <div className="lists-header-products">
          <div className="heading-txt">Product Inventory</div>
          <div className="header-wrap-items for_products">
            <div className="header-ctas">
              <button
                className="each-cta"
                onClick={() => history.replace("/app/my-products/new/multiple")}
              >
                + Import Products
              </button>
              <button
                className="each-cta"
                onClick={() => history.replace("/app/my-products/new")}
              >
                + New Product
              </button>
            </div>
          </div>
        </div>
        <div className="list-contanier">
          <div className="list-content-wrap cards products-list all-products">
            <div className="header-wrap-items for_products inner">
              <div className="nav-pills" id="tabNav">
                {statuses.map((status) => (
                  <button
                    key={status}
                    className={`nav-link ${activeStatus === status ? "active-status" : ""
                      }`}
                    onClick={() => {
                      setActiveStatus(status);
                      setPageNumber(1);
                    }}
                  >
                    {status}
                  </button>
                ))}
              </div>
              <div className="list-filters-wrap">
                <div className="each-filter for-search">
                  <div className="search-container">
                    <input
                      type="text"
                      placeholder="Search inventory"
                      value={searchText}
                      onChange={(e) => {
                        const txtValue = e.target.value.trim();
                        setSearchText(e.target.value);
                        if (txtValue.length >= 3) {
                          setActiveFilters(null);
                          setPageNumber(1);
                        }
                        if (txtValue.length === 0) {
                          setPageNumber(1);
                        }
                      }}
                      className="mobile-search-bar"
                    />

                    {screenResolution?.width <= 1024 && (
                      <button
                        type="button"
                        onClick={() => {
                          if (!showFilterModal) {
                            const aggregateResults =
                              pageProps?.getProductListRequest?.request_data?.response?.aggregateResults;

                            const categoriesData = Array.isArray(aggregateResults)
                              ? aggregateResults.find((item: any) => item?.name === "Categories")
                              : null;

                            const categories =
                              Array.isArray(categoriesData?.buckets)
                                ? categoriesData.buckets.map((bucket: any) => ({
                                  label: bucket?.key ?? "",
                                  value: bucket?.value ?? "",
                                }))
                                : [];

                            setCategoryList(categories || []);

                            setShowFilterModal(true);
                          }
                        }}
                        className="mobile-filter-btn"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="4" y1="6" x2="20" y2="6" />
                          <circle
                            cx="12"
                            cy="6"
                            r="2"
                            fill="white"
                            stroke="black"
                          />
                          <line x1="4" y1="12" x2="20" y2="12" />
                          <circle
                            cx="8"
                            cy="12"
                            r="2"
                            fill="white"
                            stroke="black"
                          />
                          <line x1="4" y1="18" x2="20" y2="18" />
                          <circle
                            cx="16"
                            cy="18"
                            r="2"
                            fill="white"
                            stroke="black"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
                {screenResolution?.width >= 1024 && (
                  <button
                    className="filter-button"
                    onClick={() => {
                      if (!showFilterModal) {
                        const aggregateResults =
                          pageProps?.getProductListRequest?.request_data?.response?.aggregateResults;

                        const categoriesData = Array.isArray(aggregateResults)
                          ? aggregateResults.find((item: any) => item?.name === "Categories")
                          : null;

                        const categories =
                          Array.isArray(categoriesData?.buckets)
                            ? categoriesData.buckets.map((bucket: any) => ({
                              label: bucket?.key ?? "",
                              value: bucket?.value ?? "",
                            }))
                            : [];

                        setCategoryList(categories || []);
                        setShowFilterModal(true);
                      }
                    }}
                    type="button"
                  >
                    {screenResolution?.width >= 1024 && (
                      <span className="filter-text">Filter by</span>
                    )}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="4" y1="6" x2="20" y2="6" />
                      <circle
                        cx="12"
                        cy="6"
                        r="2"
                        fill="white"
                        stroke="black"
                      />
                      <line x1="4" y1="12" x2="20" y2="12" />
                      <circle
                        cx="8"
                        cy="12"
                        r="2"
                        fill="white"
                        stroke="black"
                      />
                      <line x1="4" y1="18" x2="20" y2="18" />
                      <circle
                        cx="16"
                        cy="18"
                        r="2"
                        fill="white"
                        stroke="black"
                      />
                    </svg>
                  </button>
                )}
              </div>

              {pageProps.bulkProductUpdateRequest.is_request_processing && (
                <div className="request_on">
                  {bulkAction === "edit"
                    ? `Updating ${getUpdatedRows().length} products...`
                    : ""}
                  {bulkAction === "delete"
                    ? `Deleting ${deleteCount} products...`
                    : ""}
                </div>
              )}
              {pageProps.deleteStoreProductRequest.is_request_processing && (
                <div className="request_on">
                  {`Deleting ${deleteCount} products...`}
                </div>
              )}
              {/* {(pageProps.bulkProductUpdateRequest.request_status === "BULK_UPDATE_SUCCESS" ||
                                pageProps.deleteStoreProductRequest.request_status === "DELETE_A_PRODUCT_SUCCESS") && (
                                    <AlertMsg
                                        type="success"
                                        message={
                                            pageProps.bulkProductUpdateRequest.request_status === "BULK_UPDATE_SUCCESS"
                                                ? bulkAction === "edit"
                                                    ? `Successfully Updated ${formattedData.length} products`
                                                    : bulkAction === "delete"
                                                        ? `Successfully Deleted ${deleteCount} products`
                                                        : ""
                                                : `Successfully Deleted ${deleteCount} products`
                                        }
                                    />
                                )} */}
            </div>
            {pageProps?.getProductListRequest?.request_status === "GET_PRODUCTS_SUCCESS" && (
              <>
                {pageProps?.bulkProductUpdateRequest?.request_status === "BULK_UPDATE_FAILURE" && (
                  <AlertMsg
                    type="error"
                    message={
                      pageProps?.bulkProductUpdateRequest?.request_data?.error ||
                      "Bulk update failed. Please try again."
                    }
                  />
                )}

                {pageProps?.deleteStoreProductRequest?.request_status === "DELETE_A_PRODUCT_FAILURE" && (
                  <AlertMsg
                    type="error"
                    message={
                      pageProps?.deleteStoreProductRequest?.request_data?.error ||
                      "Product deletion failed. Please try again."
                    }
                  />
                )}

                {pageProps?.getProductListRequest?.request_data?.response?.results?.length > 0 && (
                  <div>
                    <div className="all-items">
                      <div className="all-items-list for-products">
                        {screenResolution?.width >= 1025 && (
                          <TableComponent
                            childComponent={
                              <ReportTable
                                reportData={shownData || []}
                                handleBulkDelete={handleBulkDelete}
                                handleBulkUpdate={handleBulkUpdate}
                                handleBulkReactivate={handleBulkReactivate}
                              />
                            }
                          />
                        )}

                        {screenResolution?.width <= 1024 &&
                          !!pageProps?.getProductListRequest?.request_data?.response && (
                            <MobileDataGrid
                              reportData={
                                pageProps?.getProductListRequest?.request_data?.response || {}
                              }
                            />
                          )}

                        {pageProps?.getProductListRequest?.request_data?.response
                          ?.totalNumberOfRecords > (pageSize || 0) && (
                            <CustomPagination
                              pageCount={
                                pageProps?.getProductListRequest?.request_data?.response
                                  ?.totalNumberOfPages || 1
                              }
                              forcePage={
                                (pageProps?.getProductListRequest?.request_data?.response
                                  ?.pageNumber || 1) - 1
                              }
                              onPageChange={handlePageClick}
                              pageRangeDisplayed={4}
                              renderOnZeroPageCount={null}
                              currentPageNumber={pageNumber || 1}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                )}

                {pageProps?.getProductListRequest?.request_data?.response?.results?.length === 0 && (
                  <div className="no-products">
                    <div className="empty-msg">No products found</div>
                  </div>
                )}
              </>
            )}

            {pageProps?.getProductListRequest?.request_status === "GET_PRODUCTS_PENDING" && (
              <LoadingItem />
            )}

            {pageProps?.getProductListRequest?.request_status === "GET_PRODUCTS_FAILURE" && (
              <AlertMsg
                type="error"
                message={
                  pageProps?.getProductListRequest?.request_data?.error ||
                  "Failed to load products. Please try again."
                }
              />
            )}

          </div>
        </div>
      </div>
      <NotificationPopup
        isOpen={showBulkUpdateModal}
        onClose={() => {
          setFormattedData([]);
          setDeleteCount(0);
          setShowBulkUpdateModal(false);
          setBulkAction("");
        }}
        message={bulkUpdateSuccessMessage}
      />
      {showFilterModal && (
        <FilterModal
          show={showFilterModal}
          allCategories={categoryList}
          pageProps={pageProps}
          onHide={() => setShowFilterModal(false)}
          filterValues={productFilterValues}
          setFilterValues={setProductFilterValues}
          onSearch={(filters) => {
            setProductFilterValues({
              ...productFilterValues,
              ...filters,
              minPrice: String(filters.minPrice),
              maxPrice: String(filters.maxPrice),
            });
            setSearchText("");
            setActiveFilters(filters);
            setPageNumber(1);
            setShowFilterModal(false);
          }}
          onExport={() => console.log("Exporting to CSV")}
          onReset={() => {
            setProductFilterValues({
              productNames: "",
              category: [],
              status: "All",
              minPrice: "0",
              maxPrice: "1000",
              lowStockOnly: false,
            });
            setActiveFilters(null);
            setSearchText("");
            setPageNumber(1);
            setShowFilterModal(false);
            getProducts({
              pageProps,
              payload: `Page=1&Size=${pageSize}`,
            });
          }}
        />
      )}
      <DeleteConfirmModal
        isOpen={showDeleteConfirmModal}
        onClose={() => {
          setShowDeleteConfirmModal(false);
          setItemToDelete(null);
        }}
        onConfirm={confirmDeleteAction}
        deleteType={deleteType}
      />
    </div>
  );
};
